import { Check } from "lucide-react";

import logo from "../../../../assets/Container.svg";

import { styles as s } from "../../styles/signupstyles";

import {
    FEATURES,
    SIGNUP_TEXT,
} from "../../domain/constants/constants";

export default function AuthLeftPanel() {
    return (
        <div className={s.leftPanel}>
            {/* Glow */}
            <div className={s.glow} />

            <div className={s.leftContent}>
                {/* Logo */}

                <div>
                    <img
                        src={logo}
                        alt="Tullu Logo"
                    />
                </div>

                {/* Hero */}

                <div className={s.headingContainer}>
                    <h1 className={s.heading}>
                        {SIGNUP_TEXT.heroTitle}
                    </h1>

                    <h2 className={s.headingItalic}>
                        {SIGNUP_TEXT.heroSubtitle1}
                    </h2>

                    <h2 className={s.headingItalic}>
                        {SIGNUP_TEXT.heroSubtitle2}
                    </h2>

                    <p className={s.description}>
                        {SIGNUP_TEXT.heroDescription}
                    </p>

                    {/* Features */}

                    <div className={s.featureList}>
                        {FEATURES.map((feature) => (
                            <div
                                key={feature}
                                className={s.featureItem}
                            >
                                <div className={s.featureIcon}>
                                    <Check size={14} />
                                </div>

                                <span className={s.featureText}>
                                    {feature}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer */}

                <p className={s.footer}>
                    {SIGNUP_TEXT.copyright}
                </p>
            </div>
        </div>
    );
}